import { render, staticRenderFns } from "./FooterDaTabela.vue?vue&type=template&id=0eb9be68&scoped=true"
import script from "./FooterDaTabela.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterDaTabela.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FooterDaTabela.vue?vue&type=style&index=0&id=0eb9be68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb9be68",
  null
  
)

export default component.exports